class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener(
            "keyup",
            (evt) => evt.code === "Escape" && this.close()
        );
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector("#cart-icon-bubble");
        cartLink.setAttribute("role", "button");
        cartLink.setAttribute("aria-haspopup", "dialog");
        cartLink.addEventListener("click", (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener("keydown", (event) => {
            if (event.code.toUpperCase() === "SPACE") {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
            this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add("animate", "active");
        });

        this.addEventListener(
            "transitionend",
            () => {
                const containerToTrapFocusOn = this.classList.contains(
                    "is-empty"
                )
                    ? this.querySelector(".drawer__inner-empty")
                    : document.getElementById("CartDrawer");
                const focusElement =
                    this.querySelector(".drawer__inner") ||
                    this.querySelector(".drawer__close");
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        document.body.classList.add("cart-opened");
    }

    close() {
        this.classList.remove("active");
        removeTrapFocus(this.activeElement);
        document.body.classList.remove("cart-opened");
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute("role", "button");
        cartDrawerNote.setAttribute("aria-expanded", "false");

        if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
            cartDrawerNote.setAttribute(
                "aria-controls",
                cartDrawerNote.nextElementSibling.id
            );
        }

        cartDrawerNote.addEventListener("click", (event) => {
            event.currentTarget.setAttribute(
                "aria-expanded",
                !event.currentTarget.closest("details").hasAttribute("open")
            );
        });

        cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    }

 renderContents(parsedState) {
  const inner = this.querySelector(".drawer__inner");
  if (inner && inner.classList.contains("is-empty")) inner.classList.remove("is-empty");

  this.productId = parsedState.id;

  // Update sections
  this.getSectionsToRender().forEach((section) => {
    const html = parsedState.sections && parsedState.sections[section.id];
    if (!html) return;

    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
    if (!sectionElement) return;

    sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
  });

  // 🧠 Update header item count manually (with giftbox adjustment)
  const liveCart = window?.Shopify?.cart || null;
  const countEl = this.querySelector(".drawer__heading--items");
  if (countEl) {
    let itemCount = parsedState.item_count !== undefined ? parsedState.item_count : liveCart?.item_count;
    
    // Calculate adjusted count by subtracting giftbox pack numbers
    if (liveCart && liveCart.items) {
      let giftboxSubtraction = 0;
      liveCart.items.forEach(item => {
        const itemTitle = (item.title || item.product_title || '').toLowerCase();
        if (itemTitle.includes('giftbox') || itemTitle.includes('gift set') || itemTitle.includes('build your')) {
          let packNumber = 0;
          if (itemTitle.includes('3 pack') || itemTitle.includes('3-pack')) {
            packNumber = 3;
          } else if (itemTitle.includes('5 pack') || itemTitle.includes('5-pack')) {
            packNumber = 5;
          }
          if (packNumber > 0) {
            giftboxSubtraction += packNumber * (item.quantity || 1);
          }
        }
      });
      itemCount = Math.max(0, (itemCount || 0) - giftboxSubtraction);
    }
    
    if (itemCount !== undefined) {
      countEl.textContent = `${itemCount} ${itemCount === 1 ? "item" : "items"}`;
    }
  }

  // 🧮 Update total in checkout button
  const newCheckout = document
    .createRange()
    .createContextualFragment(this.getSectionInnerHTML(parsedState.sections["cart-drawer"], "#CartDrawer-Checkout"))
    .querySelector("#CartDrawer-Checkout");

  const checkoutBtn = this.querySelector("#CartDrawer-Checkout");
  if (checkoutBtn && newCheckout) {
    checkoutBtn.innerHTML = newCheckout.innerHTML;
  }

  // 💰 Update "You are saving..." total if exists
  const newSavings = document
    .createRange()
    .createContextualFragment(this.getSectionInnerHTML(parsedState.sections["cart-drawer"], ".cart-total-savings"))
    .querySelector(".cart-total-savings");

  const savingsEl = this.querySelector(".cart-total-savings");
  if (savingsEl && newSavings) {
    savingsEl.innerHTML = newSavings.innerHTML;
  }

  // Refresh internal cart data (if function exists)
  setTimeout(() => {
    if (typeof fetchCart === "function") fetchCart();
  }, 100);

  // Fire event for any external listeners
  document.dispatchEvent(new CustomEvent("cartDrawer:render", { detail: parsedState }));
}


getSectionInnerHTML(html, selector = ".shopify-section") {
  const doc = new DOMParser().parseFromString(html, "text/html");
  if (!selector) return doc.body.innerHTML || "";
  const el = doc.querySelector(selector);
  return el ? el.innerHTML : (doc.body && doc.body.innerHTML) ? doc.body.innerHTML : "";
}


    openCloseCart() {
        setTimeout(() => {
            this.querySelector("#CartDrawer-Overlay").addEventListener(
                "click",
                this.close.bind(this)
            );
            this.open();
        });
    }


    getSectionsToRender() {
        return [
            {
                id: "cart-drawer",
                selector: "#CartDrawer",
            },
            {
                id: "cart-icon-bubble",
            },
        ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: "CartDrawer",
                section: "cart-drawer",
                selector: ".drawer__inner",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
        ];
    }
}

customElements.define("cart-drawer-items", CartDrawerItems);
